module.exports = __webpack_public_path__ + "static/avatar-placeholder-ecd56e35150a04397f32ce69a2440a38.svg";